import { render, staticRenderFns } from "./yysfa.vue?vue&type=template&id=6b2e566b&scoped=true"
import script from "./yysfa.vue?vue&type=script&lang=js"
export * from "./yysfa.vue?vue&type=script&lang=js"
import style0 from "./yysfa.vue?vue&type=style&index=0&id=6b2e566b&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2e566b",
  null
  
)

export default component.exports